import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Paginator } from '../models/paginator';
import { CrawlUrl, CrawlerExecutionSummary } from '../models/crawlerUrl';
import { DiscoveredUrl } from '../models/discoveredUrls';

export type CrawlUrlsFilters = {
  query?: string;
  status?: string;
  executionId?: string;
};

@Injectable({
  providedIn: 'root'
})
export class CrawlUrlsService {

  constructor(
    private http: HttpClient
  ) {
  }

  // The pages an exploration found that no capture took (a reminder in the capture step).
  retrieveNotCaptured(integrationId: string, limit: number): Promise<Paginator<DiscoveredUrl>> {
    return firstValueFrom(
      this.http.get<Paginator<DiscoveredUrl>>(
        `${environment.backend}/integrations/${integrationId}/crawl-urls/not-captured`,
        { params: new HttpParams().set('page', 1).set('limit', limit).set('offset', 0).set('sort', 'url') },
      )
    );
  }

  listExecutions(integrationId: string): Promise<CrawlerExecutionSummary[]> {
    return firstValueFrom(
      this.http.get<CrawlerExecutionSummary[]>(
        `${environment.backend}/integrations/${integrationId}/executions`
      )
    );
  }

  retrieveCrawlUrlsPaginated(
    integrationId: string,
    pageNumber: number,
    limit: number,
    offset: number,
    sort?: string,
    filters?: CrawlUrlsFilters,
  ): Promise<Paginator<CrawlUrl>> {
    let params = new HttpParams()
      .set('page', pageNumber)
      .set('limit', limit)
      .set('offset', offset);

    if (sort) {
      params = params.set('sort', sort);
    }

    if (filters?.query) {
      params = params.set('query', filters.query);
    }

    if (filters?.status) {
      params = params.set('status', filters.status);
    }

    if (filters?.executionId) {
      params = params.set('executionId', filters.executionId);
    }

    return firstValueFrom(
      this.http.get<Paginator<CrawlUrl>>(
        `${environment.backend}/integrations/${integrationId}/crawl-urls/search`,
        { params }
      )
    );
  }
}
